import React from 'react';
import {observer} from 'mobx-react';
import s from '../../s';
import ATCButton from './atc-button';
import ShareIcon from '../share-icon';
import {Portal} from '../../../util';

declare const modalOpen: (id: string) => void;

interface IATCProps {
    lite?: boolean;
}

const ATC: React.FC<IATCProps> = observer(({lite}) => {
    return (
        <div className="position-relative">
            <div className="atc-lg">
                <div className="atc-buttons-container">
                    <ATCButton additionalClass={lite ? 'sm' : 'lg'} />
                </div>

                {!s.IsPortal3 && !lite && s.isRetail && (
                    <div className="return">
                        <button
                            className="link link-btn"
                            onClick={() => modalOpen('modal-return-policy')}
                            type="button"
                            aria-label="View information about return policy"
                            aria-haspopup="dialog"
                            aria-controls="modal-return-policy"
                        >
                            Easy, {Portal && Portal.PortalID < 3 ? '120' : '30'}-day return policy
                        </button>
                    </div>
                )}

                {s.ui.show_atc && (
                    <div className="sticky-atc">
                        <ATCButton additionalClass="sticky" />
                    </div>
                )}

                {s.ui.show_atc && s.ps.atc_error && s.ps.atc_error !== '' && (
                    <div className="alert alert-danger mt-1">
                        <b>Error</b>
                        <div className="mt-2">{s.ps.atc_error}</div>
                    </div>
                )}
            </div>

            {!s.IsPortal3 && window.innerWidth > 1200 && (
                <div style={{position: 'absolute', top: 8, left: 0}}>
                    <ShareIcon />
                </div>
            )}
        </div>
    );
});

export default ATC;
